import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { AbApp } from 'app/abstract/services/app.abstract';

@Injectable({ providedIn: 'root' })
export class AppService extends AbApp {

  url = environment.urlApi;

  constructor(public http: HttpClient) {
    super()
    this.http = http;
  }

public getAll<T = any>(endPoint: string, filter?: string): Observable<T> {
  if (filter) {
    return this.http.get<T>(this.url + endPoint + filter);
  }
  return this.http.get<T>(this.url + endPoint);
}

  public get<T = any>(endPoint: string, id?: any, params?: any): Observable<T> {
    if (id)
      return this.http.get<T>(this.url + endPoint + id);

    return this.http.get<T>(this.url + endPoint, { params: params });
  }

  public getBlob(endPoint: string) {
    return this.http.get(this.url + endPoint, { responseType: 'blob' });
  }

  public save(endPoint: string, entity: any) {
    if (entity.id)
      return this.http.put(this.url + endPoint + entity.id, entity);

    return this.post(endPoint, entity);
  }

  public post(endPoint: string, entity: any): Observable<any> {
    return this.http.post(this.url + endPoint, entity);
  }

  public put(endPoint: string, id: any, entity: any): Observable<any> {
    return this.http.put(`${this.url}${endPoint}/${id}`, entity);
  }

  public delete(endPoint: string, id: number) {
    return this.http.delete(this.url + endPoint + id);
  }

  public deleteComBody(endPoint: string, body: any) {
    return this.http.delete(this.url + endPoint, {
      body: body,
    });
  }

  public getResponseType(endPoint: string, responseType?: any) {
    return this.http.get(this.url + endPoint, responseType);
  }

  public getRelatorioS3(tipo: string): Observable<any> {
    return this.get(`relatorio_s3/${tipo}`);
  }

  public patch(endPoint: string, entity: any) {
    return this.http.patch(this.url + endPoint, entity);
  }

  public putComParam(endPoint: string, entity: any, params: any): Observable<any> {
    return this.http.put(`${this.url}${endPoint}`, entity, params);
  }

  public deleteSemId(endPoint: string) {
    return this.http.delete(this.url + endPoint);
  }

}
